"use client";

import { create } from "zustand";

const useModalStore = create((set) => ({
  modal: null,
  openModal: (type, meta) =>
    set({
      modal: {
        type,
        meta,
      },
    }),
  closeModal: (modal) =>
    set({
      modal: null,
    }),
}));

export default useModalStore;
